import { Button, Space, Switch, Table, Modal, Input } from 'antd';
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { addorEditPrompts, getPrompts } from '../../redux/SuperAdmin/SuperAdminActions';

const BrandList = ({ companiesDetails }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const usertoken = useSelector((state) => state.Auth.token);
    const userData = useSelector((state) => state.Auth.userData);
    const { PropmtsData, PropmtsLoading, GetPropmtsLoading } = useSelector((state) => state.SuperAdminReducer);
    const [currentToken, setcurrentToken] = useState(null)

    const dispatch = useDispatch()
    const [Content, setContent] = useState('');
    const { TextArea } = Input;
    const [brands, setBrands] = useState(
        companiesDetails?.brands?.map((brand, index) => ({
            key: index,
            name: brand.brandname,
            isActive: brand.isActive,
            token: brand?.token
        })) || []
    );


    useEffect(() => {
        if (PropmtsData !== null) {
            setContent(PropmtsData?.content)
        }
    }, [PropmtsData])


    const onChange = (checked, record) => {
        setBrands((prevBrands) =>
            prevBrands.map((brand) =>
                brand.key === record.key
                    ? { ...brand, isActive: checked }
                    : brand
            )
        );
    };

    const showModal = (record) => {
        let data = {
            webtoken: record?.token,
            _id: userData?._id

        }
        dispatch(getPrompts(data, usertoken))
        setcurrentToken(record?.token)

        setIsModalOpen(true);
    };


    const handleCancel = () => {
        setIsModalOpen(false);
        setcurrentToken(null);
        setContent("");
    };
    const handleOk = () => {
        let data = {
            webtoken: currentToken,
            content: Content,
            _id: userData?._id
        }
        dispatch(addorEditPrompts(data, usertoken, handleCancel))

    };


    const columns = [
        {
            title: 'Brand Name',
            dataIndex: 'name',
            key: 'name',
            render: (text) => <a>{text}</a>,
        },
        {
            title: 'Action',
            key: 'action',
            render: (_, record) => (
                <Switch size="small"
                    checked={record.isActive}
                    onChange={(checked) => onChange(checked, record)} />
            ),
        },
        {
            title: 'Action',
            key: 'token',
            render: (_, record) => (
                <Button onClick={() => showModal(_)}>Add Prompts</Button>
            ),
        },
    ];

    return (
        <div className="pagiTable">
            <h2>Brand List</h2>
            <Table columns={columns} dataSource={brands} pagination={false} />
            <Modal
                width={1020}
                title="Add Prompts"
                closable={{ 'aria-label': 'Custom Close Button' }}
                open={isModalOpen}
                confirmLoading={PropmtsLoading}
                onOk={handleOk}
                onCancel={handleCancel}
            >
                <TextArea value={Content} onChange={(e) => setContent(e.target.value)} rows={20} placeholder="Website Content Here..." />

            </Modal>

        </div>
    );
};

export default BrandList;
